import normalizeError from '../../utils/normalizeError';
import instance from '../scorpiusInstance';
import {
  UPDATE_APP_USER_START,
  UPDATE_APP_USER_SUCCESS,
  UPDATE_APP_USER_ERROR,
} from '../types';

export const updateAppUserStart = (orgId, appName) => ({
  type: UPDATE_APP_USER_START,
  orgId,
  appName,
});

export const updateAppUserSuccess = (orgId, appName, user) => ({
  type: UPDATE_APP_USER_SUCCESS,
  orgId,
  appName,
  user,
});

export const updateAppUserError = (orgId, appName, error) => ({
  type: UPDATE_APP_USER_ERROR,
  orgId,
  appName,
  error,
});

/**
 * Updates a user's role for the given organization's app.
 * @param {String} orgId
 * @param {String} appName
 * @param {Object} user
 * @param {String} user.email
 * @param {String} user.role
 */
export const updateAppUser = (orgId, appName, user) => async dispatch => {
  dispatch(updateAppUserStart(orgId, appName));
  try {
    await instance.patch(
      `/organizations/${orgId}/${appName}/users/${user.email}`,
      { role: user.role },
      { headers: { retry: true } },
    );
    return dispatch(updateAppUserSuccess(orgId, appName, user));
  } catch (error) {
    throw dispatch(updateAppUserError(orgId, appName, normalizeError(error)));
  }
};

export default updateAppUser;
